import React from "react";
import PropTypes from "prop-types";

function ToolTipTSpanLabel({ children, fill = "#4682B4", ...rest }) {
  return (
    <tspan className="react-stockcharts-tooltip-label" fill={fill} {...rest}>
      {children}
    </tspan>
  );
}

ToolTipTSpanLabel.propTypes = {
  children: PropTypes.node.isRequired,
  fill: PropTypes.string,
};

export default ToolTipTSpanLabel;
